const brandsId: Record<string, string> = {
  demo: '496',
  DCT: '3294',
  reunion: '1838',
};

export const getBrandId = (customerId: string): string => {
  return brandsId[customerId];
};
